<style lang="scss" scoped>
.container {
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  padding: 0 20px 20px 20px;
}
</style>

<template>
  <div class="container">
    <div style="display: flex; justify-content: flex-end;">
      <el-button plain size="small" icon="el-icon-refresh" @click="resetSession">{{ $t('chongzhihuihua') }}</el-button>
    </div>
    <!-- style="width: 600px;" -->
    <div v-loading="iframeLoading">
      <iframe :key="chatbotKey" id="chatbot" :src="url" style="width: 100%; height: 100%; min-height: 700px" frameborder="0" allow="microphone"> </iframe>
    </div>
  </div>
</template>

<script type="text/javascript">
import pako from 'pako';

export default {
  name: 'web_ai_application_process_optimization_index',
  data() {
    return {
      // 用于重新加载iframe
      chatbotKey: 1,
      iframeLoading: false,
      // 传递给iframe的参数
      inputs: {
        tokenKey: ''
      }
    };
  },
  computed: {
    url() {
      const a = 'http://124.71.112.134/chatbot/ckNbxjjkhJzj8R1b?t=' + new Date().getTime() + '&' + this.parseParams();
      console.log('url', a);
      return a;
    }
  },
  created() {
    this.inputs.tokenKey = localStorage.getItem('token');
  },
  methods: {
    // 重置会话
    resetSession() {
      this.iframeLoading = true;
      this.chatbotKey++;
      this.$nextTick(() => {
        const iframe = document.getElementById('chatbot');
        iframe.onload = () => {
          this.iframeLoading = false;
        };
      });
    },
    // 解析参数并压缩
    parseParams() {
      const inputs = this.inputs;
      const compressedInputs = {};
      Object.entries(inputs).map(([key, value]) => {
        // 将字符串转换为 Uint8Array
        const uint8Array = new TextEncoder().encode(value);
        // 使用 pako 进行 Gzip 压缩
        const compressed = pako.gzip(uint8Array);
        // 将压缩后的 Uint8Array 转换为 Base64 字符串
        const base64String = btoa(String.fromCharCode.apply(null, compressed));
        compressedInputs[key] = base64String;
      });
      return new URLSearchParams(compressedInputs);
    }
  }
};
</script>
